module.exports = __webpack_public_path__ + "shapes-small.png?b879fb3e5d3298d029744cf08c5baea4";